import { OnTrackRegentsCtrl } from './on-track-regents.controller';

export const OnTrackRegentsStepComponent = {
  controller: OnTrackRegentsCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./on-track-regents.html'),
};
